import { combineReducers } from "redux";
import testReducer from "./Test/reducer";
import screenReducer from "./Screen/reducer";
import cameraReducer from "./Camera/reducer";
import candidateReducer from "./Candidate/reducer";
import currentQuestion from "./CurrentQuestion/reducer";
import peripheralReducer from "./Peripheral/reducer";

const rootReducer = combineReducers({
  testReducer,
  cameraReducer,
  screenReducer,
  candidateReducer,
  currentQuestion,
  peripheralReducer,
});

export default rootReducer;
